/**
 * Ryan O'Dowd
 * 2025-01-12
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    container: {
      flexWrap: 'wrap',
    },
    errorMessageAndButtonsWrapper: {
      flex: 1,
      flexDirection: 'column',
      alignItems: 'center',
      gap: globalScale * 4,
    },
    errorMessageText: {
      color: colors.alert,
      alignSelf: 'flex-start',
    },
    buttonsWrapper: {
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      gap: globalScale * 8,
    },
  };
};

export default getStyles;
